import React from "react";
import Hero from "../components/Hero";
import List from "../components/Lists";
import imageBig from "../assets/images/team-header-big.jpg";
import imageSmall from "../assets/images/team-header-small.jpg";
import { ContentWrapper, Flex, Box, IndexTitle } from "../components/Layout";
import { TeamCard, TeamDescription } from "../components/Cards";
import feather from "../utils/feather.js";
import colors from "../utils/colors.js";
import Card from "../components/Cards";
import SEO from '../components/SEO';

export default ({ data }) => {
  const location = data.allBusinessJson.edges[0].node.locations;
  const myTitle = 'Structured Cabling, Data Networks, Low Voltage Nationwide | PCS'
const myDesc = 'Preferred Cabling Systems installs and designs data networks for the biggest hospitality brands across the US. PCS is a nationwide low voltage contractor.'
  return <div>
    <SEO title={myTitle}
      description={myDesc}
    />
      <Hero imageBig={imageBig} imageSmall={imageSmall}>
        <Box color="white" p={[3, 3, 4]} align="left">
          <h1>Data Experts With Offices in Tennessee, Georgia, and Florida</h1>
        </Box>
      </Hero>
    <Box color={colors.black}
      py={"1rem"}
      pl={["1em", "2em", "3em", "10em"]}
      pr={["1em", "2em", "3em", "10em"]}
      align="center">
      <p> Come visit us at our office.Call to schedule an appointment <a href="tel:877-307-8131"> 877 & #8211;307 & #8211;8131 </a></p>
    </Box>
      <Box color="red" p={[2, 3, 2]} align="center">
        <Flex wrap={["wrap", "wrap", "wrap"]} justify="space-between">
          {location.map(item => {
            return <Box key={item.id} color="red" width={[1, 1, 1 / 3.3]}>
                <Card> 
                  <h3 key={item.id}>{item.city} Office </h3>
                  <h5>{item.street}</h5>
                  <h5>
                    {item.city}, {item.state} {item.zip}
                  </h5>
                </Card>
              </Box>;
          })}
        </Flex>
      </Box>

    </div>;
};

export const query = graphql`
  query LocationQuery {
    allBusinessJson {
      edges {
        node {
          locations {
            street
            city
            zip
            state
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/locations.js